import { Injectable } from '@angular/core';
import { ApiPath, ApiService, YearMonth } from '@financial/arch';
import { CashFlowByPeriod } from '@financial/domain';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class CashFlowByPeriodService {
  private apiPath: ApiPath;

  constructor(api: ApiService) {
    this.apiPath = api.root.path('reports').path('cashFlowByPeriod');
  }

  findBy(yearMonth: YearMonth): Observable<CashFlowByPeriod> {
    const params = new HttpParams().append('monthReference', yearMonth.toDefaultString());

    return this.apiPath
      .getJson<CashFlowByPeriod>({ params: params })
      .pipe(retry(3));
  }
}
